/**
 * API 请求层 — 使用系统自带 /api 路由
 */
import { API_BASE } from '../config.js'

async function request(path, options = {}) {
  const url = `${API_BASE}${path}`
  try {
    const res = await fetch(url, {
      headers: { 'Content-Type': 'application/json', ...options.headers },
      ...options,
    })
    const json = await res.json()
    if (!res.ok) throw new Error(`API Error: ${res.status}`)
    // 系统返回格式: { code: 200, msg: "success", data: {...} }
    return json.data || json
  } catch (err) {
    console.warn('[API] request failed:', path, err.message)
    return null
  }
}

// 站点配置（无需鉴权）
export async function getSiteConfig() {
  return request('/site/config')
}

// 域名列表（无需鉴权）
export async function getHotDomains() {
  return request('/site/domains')
}

// 热门套餐（无需鉴权）
export async function getHotPackages() {
  return request('/site/hotPackages')
}

// 友情链接（无需鉴权）
export async function getFriendlinks() {
  return request('/site/friendlinks')
}

// 公告分类（无需鉴权）
export async function getAnnouncementCategories() {
  return request('/announcement/categories')
}

// 公告列表（无需鉴权），支持分页和分类筛选
export async function getAnnouncementList(params = {}) {
  const query = new URLSearchParams()
  if (params.category_id) query.set('category_id', params.category_id)
  if (params.page) query.set('page', params.page)
  if (params.limit) query.set('limit', params.limit)
  const qs = query.toString() ? `?${query.toString()}` : ''
  return request(`/announcement/list${qs}`)
}

// 公告详情（无需鉴权）
export async function getAnnouncementDetail(id) {
  return request(`/announcement/detail?id=${id}`)
}
